import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MixpanelService } from '../mixpanel.service';
import { AuthService } from '../auth.service';
import { RouteMapperUtils } from '../../utils/route-mapper.utils';

@Injectable({
  providedIn: 'root',
})
export class PageViewTrackingService {
  private readonly router = inject(Router);
  private readonly mixpanelService = inject(MixpanelService);
  private readonly authService = inject(AuthService);
  private readonly routeMapper = inject(RouteMapperUtils);

  private lastTrackedUrl: string | null = null;

  constructor() {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe(event => this.handleNavigationEnd(event));
  }

  private handleNavigationEnd(event: NavigationEnd): void {
    const url = event.urlAfterRedirects;
    if (url === this.lastTrackedUrl) {
      return;
    }
    this.lastTrackedUrl = url;

    const { params, queryParams, routePath } = this.getActiveRouteInfo();
    const currentUser = this.authService.getCurrentUser();

    this.mixpanelService.trackPageView(url, {
      nomeTela: this.routeMapper.getNomeTela(url, routePath),
      rota: routePath,
      url,
      parametros: params,
      parametrosQuery: queryParams,
      usuarioEmail: currentUser?.email ?? null,
      usuarioNome: currentUser?.fullName ?? null,
      usuarioCpf: currentUser?.cpf ?? null,
      usuarioRoles: currentUser?.roles ?? null,
    });
  }

  private getActiveRouteInfo(): {
    params: Record<string, string>;
    queryParams: Record<string, string>;
    routePath: string | null;
  } {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }

    return {
      params: { ...route.snapshot.params },
      queryParams: { ...route.snapshot.queryParams },
      routePath: route.snapshot.routeConfig?.path ?? null,
    };
  }
}
